import React, { forwardRef } from "react";
import styled from "@emotion/styled";
import Logo from "./Logo";
import OriginEntry from "./OriginEntry";
import BackgroundEntry from "./BackgroundEntry";
import Inventory from "./Inventory";
import Extras from "./Extras";

const Wrapper = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  max-height: 90%;
  max-width: 80%;
  min-height: 90%;
  height: 90%;
  flex-direction: column;
  font-family: "VT323", monospace;
  color: black;
  background-color: white;
  margin: auto;

  & svg {
    width: 75%;
  }
`;

const AsterisksWrapper = styled.div`
  font-size: 11px;
  padding-top: 16px;
  padding-bottom: 16px;
  font-family: "Press Start 2P", monospace;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
`;

const FooterWrapper = styled.div`
  font-size: 11px;
  padding-top: 16px;
  padding-bottom: 12px;
  font-family: "Press Start 2P", monospace;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  white-space: nowrap;
`;

const DeathBulletinBoardSystem = styled.div`
  font-size: 12px;
  font-family: "Press Start 2P", monospace;
`;

const PersonalDataSheet = styled.div`
  margin-top: 8px;
  font-size: 10px;
  font-family: "Press Start 2P", monospace;
`;

const BasicInformation = styled.div`
  width: 100%;
  height: 16px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const InfoTitle = styled.div`
  font-family: "Press Start 2P", monospace;
  font-size: 10px;
  font-weight: 400;
  text-align: center;
  margin-bottom: -2px;
`;

const InfoText = styled.div`
  font-size: 18px;
  padding-left: 12px;
  text-align: center;
`;

const Header = styled.div`
  font-family: "Press Start 2P", monospace;
  font-size: 14px;
  text-align: center;
`;

const Subheader = styled.div`
  margin-top: 4px;
  font-size: 18px;
  text-align: center;
`;

const Asterisks = () => {
  return (
    <AsterisksWrapper>
      *********************************************************
    </AsterisksWrapper>
  );
};

const ComponentToPrint = forwardRef(({ character }, ref) => (
  <Wrapper ref={ref}>
    <DeathBulletinBoardSystem>
      {"<<< DEATH BULLETIN BOARD SYSTEM >>>"}
    </DeathBulletinBoardSystem>
    <Asterisks />
    <Logo />
    <PersonalDataSheet>{"PERSONAL DATA SHEET"}</PersonalDataSheet>
    <Asterisks />
    <BasicInformation>
      <InfoWrapper>
        <InfoTitle>{"NAME"}</InfoTitle>
        <InfoText>{character.name}</InfoText>
      </InfoWrapper>
      <InfoWrapper>
        <InfoTitle>{"HIT POINTS"}</InfoTitle>
        <InfoText>{character.hitPoints}</InfoText>
      </InfoWrapper>
      <InfoWrapper>
        <InfoTitle>{"DEFENSE RATING"}</InfoTitle>
        <InfoText>{character.defenseRating}</InfoText>
      </InfoWrapper>
    </BasicInformation>
    <Asterisks />
    <Header>{"+++ ABILITY +++"}</Header>
    <br />
    <BasicInformation>
      <InfoWrapper>
        <InfoTitle>{"BODY"}</InfoTitle>
        <InfoText>{`${character.abilities.body >= 0 ? "+" : ""}${
          character.abilities.body
        }`}</InfoText>
      </InfoWrapper>
      <InfoWrapper>
        <InfoTitle>{"DEXTERITY"}</InfoTitle>
        <InfoText>{`${character.abilities.dexterity >= 0 ? "+" : ""}${
          character.abilities.dexterity
        }`}</InfoText>
      </InfoWrapper>
      <InfoWrapper>
        <InfoTitle>{"SAVVY"}</InfoTitle>
        <InfoText>{`${character.abilities.savvy >= 0 ? "+" : ""}${
          character.abilities.savvy
        }`}</InfoText>
      </InfoWrapper>
      <InfoWrapper>
        <InfoTitle>{"TECH"}</InfoTitle>
        <InfoText>{`${character.abilities.tech >= 0 ? "+" : ""}${
          character.abilities.tech
        }`}</InfoText>
      </InfoWrapper>
    </BasicInformation>
    {character.startingBonus && (
      <OriginEntry
        title={"STARTING BONUS"}
        subtitle={`${character.startingBonus.name}`}
        content={character.startingBonus.description}
      />
    )}
    <Asterisks />
    <Header>{"+++ ORIGIN +++"}</Header>
    <OriginEntry
      subtitle={`${character.origin.name.toUpperCase()}.`}
      content={character.origin.description}
    />
    <OriginEntry
      title={"ORIGIN BENEFIT"}
      subtitle={`${character.origin.benefit.name.toUpperCase()}.`}
      content={character.origin.benefit.description}
    />
    <Asterisks />
    <Header>{"+++ BACKGROUND +++"}</Header>
    <Subheader>{`${character.background.toUpperCase()}`}</Subheader>
    <BackgroundEntry title={"TRAIT"} content={`${character.trait}`} />
    <BackgroundEntry title={"DRIVE"} content={`${character.drive}`} />
    <BackgroundEntry title={"LOOKS"} content={`${character.looks}`} />
    <BackgroundEntry
      title={"PAST ALLEGIANCE"}
      content={`${character.pastAllegiance.name.toUpperCase()}. ${
        character.pastAllegiance.description
      }`}
    />
    <br />
    <Inventory character={character} />
    <Extras character={character} />
    <FooterWrapper>
      ************** HAVE A NICE DEATH IN SPACE! **************
    </FooterWrapper>
  </Wrapper>
));

export default ComponentToPrint;
